import React from 'react'
import styled from 'styled-components'
import MinusIcon from '../../assets/icons/JSX/MinusIcon'
import PlusIcon from '../../assets/icons/JSX/PlusIcon'
import Colors from '../../assets/styles/Colors'
//
//
const CountBar: React.FC<{
  initialCount?: number
  maxCount?: number
  step: number
  plusOnClick: (value: number) => void
  minusOnClick: (value: number) => void
}> = ({ initialCount = 0, maxCount = null, step, plusOnClick, minusOnClick }) => {
  //
  return (
    <Wrapper $count={initialCount}>
      <MinusButton $count={initialCount} onClick={() => minusOnClick(initialCount - step)}>
        <MinusIcon />
      </MinusButton>
      <div>{initialCount}</div>
      <PlusButton $maxCount={maxCount} $count={initialCount} onClick={() => plusOnClick(initialCount + step)}>
        <PlusIcon />
      </PlusButton>
    </Wrapper>
  )
}
//
const PlusButton = styled.button<{ $maxCount: number | null; $count: number }>`
  user-select: ${({ $maxCount, $count }) => ($maxCount && $count >= $maxCount ? 'none' : 'unsert')};
  pointer-events: ${({ $maxCount, $count }) => ($maxCount && $count >= $maxCount ? 'none' : 'unset')};
  opacity: ${({ $maxCount, $count }) => ($maxCount && $count >= $maxCount ? '0.8' : 'unset')};
`
const MinusButton = styled.button<{ $count: number }>`
  user-select: ${({ $count }) => ($count < 1 ? 'none' : 'unsert')};
  pointer-events: ${({ $count }) => ($count < 1 ? 'none' : 'unset')};
  opacity: ${({ $count }) => ($count < 1 ? '0.8' : 'unset')};
`
const Wrapper = styled.div<{ $count: number }>`
  user-select: none;
  width: fit-content;
  display: flex;
  align-items: center;
  border-radius: 4px;
  font-size: 14px;
  color: ${({ $count }) => ($count >= 1 ? Colors.white : Colors.primaryBlack)};
  background-color: ${({ $count }) => ($count >= 1 ? Colors.primaryBlack : Colors.white)};
  outline: ${({ $count }) => ($count >= 1 ? 'none' : `1px solid ${Colors.secondaryGrey}`)};

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    margin: 0px;
    width: 32px;
    height: 32px;
    background-color: transparent;
    outline: none;
    border: none;

    color: ${({ $count }) => ($count >= 1 ? Colors.white : Colors.primaryBlack)};

    &:active {
      opacity: 0.8;
    }

    svg {
      height: 8px;
      width: 8px;
      margin-bottom: -2px;
      color: ${({ $count }) => ($count >= 1 ? Colors.white : Colors.primaryBlack)};
      stroke: ${({ $count }) => ($count >= 1 ? Colors.white : Colors.primaryBlack)};
    }
  }
`
//
export default CountBar
